/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BillingAccountData,
  BillingAccountInput,
  CardData,
  ChannelOverview,
  CreateOrUpdateProjectDomainInput,
  CreateOtherSystemSourceInput,
  CreateOtherSystemSourceInsightInput,
  CreateRoleInput,
  DateRangeInput,
  DeleteOtherSystemSourceInsightInput,
  DeleteProjectDomainInput,
  ErpFilter,
  ErrorResponse,
  HostNameAndCsvLinkData,
  HostNameAndTldAndApiCurrencyCodeApiKeyData,
  HostNameAndXmlLinkData,
  HostNameApiIdApiKeyData,
  InviteUserInput,
  MarketingChannelList,
  ModifyOtherSystemSourceInput,
  ModifyOtherSystemSourceInsightInput,
  OtherSystemSourceInsight,
  OtherSystemSourceWithCentreAndDomain,
  OtherSystemType,
  PatchRoleInput,
  PaymentSetupData,
  ProjectBillingAccountInput,
  ProjectCentreWithDomains,
  ProjectData,
  ProjectDomainAdditionalPaymentData,
  ProjectDomainWithStats,
  ProjectInput,
  ProjectInvitation,
  ProjectOrderStatusSettings,
  ProjectRole,
  ProjectRoleOutput,
  ProjectRuntimeOverview,
  ProjectStatusUpdate,
  ProjectUsers200Response,
  RemoveUserInput,
  SetOwnerInput,
  SetRoleInput,
  SingleCampaignOverview,
  UpdateSubscriptionInput,
} from '../models/index';
import {
    BillingAccountDataFromJSON,
    BillingAccountDataToJSON,
    BillingAccountInputFromJSON,
    BillingAccountInputToJSON,
    CardDataFromJSON,
    CardDataToJSON,
    ChannelOverviewFromJSON,
    ChannelOverviewToJSON,
    CreateOrUpdateProjectDomainInputFromJSON,
    CreateOrUpdateProjectDomainInputToJSON,
    CreateOtherSystemSourceInputFromJSON,
    CreateOtherSystemSourceInputToJSON,
    CreateOtherSystemSourceInsightInputFromJSON,
    CreateOtherSystemSourceInsightInputToJSON,
    CreateRoleInputFromJSON,
    CreateRoleInputToJSON,
    DateRangeInputFromJSON,
    DateRangeInputToJSON,
    DeleteOtherSystemSourceInsightInputFromJSON,
    DeleteOtherSystemSourceInsightInputToJSON,
    DeleteProjectDomainInputFromJSON,
    DeleteProjectDomainInputToJSON,
    ErpFilterFromJSON,
    ErpFilterToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    HostNameAndCsvLinkDataFromJSON,
    HostNameAndCsvLinkDataToJSON,
    HostNameAndTldAndApiCurrencyCodeApiKeyDataFromJSON,
    HostNameAndTldAndApiCurrencyCodeApiKeyDataToJSON,
    HostNameAndXmlLinkDataFromJSON,
    HostNameAndXmlLinkDataToJSON,
    HostNameApiIdApiKeyDataFromJSON,
    HostNameApiIdApiKeyDataToJSON,
    InviteUserInputFromJSON,
    InviteUserInputToJSON,
    MarketingChannelListFromJSON,
    MarketingChannelListToJSON,
    ModifyOtherSystemSourceInputFromJSON,
    ModifyOtherSystemSourceInputToJSON,
    ModifyOtherSystemSourceInsightInputFromJSON,
    ModifyOtherSystemSourceInsightInputToJSON,
    OtherSystemSourceInsightFromJSON,
    OtherSystemSourceInsightToJSON,
    OtherSystemSourceWithCentreAndDomainFromJSON,
    OtherSystemSourceWithCentreAndDomainToJSON,
    OtherSystemTypeFromJSON,
    OtherSystemTypeToJSON,
    PatchRoleInputFromJSON,
    PatchRoleInputToJSON,
    PaymentSetupDataFromJSON,
    PaymentSetupDataToJSON,
    ProjectBillingAccountInputFromJSON,
    ProjectBillingAccountInputToJSON,
    ProjectCentreWithDomainsFromJSON,
    ProjectCentreWithDomainsToJSON,
    ProjectDataFromJSON,
    ProjectDataToJSON,
    ProjectDomainAdditionalPaymentDataFromJSON,
    ProjectDomainAdditionalPaymentDataToJSON,
    ProjectDomainWithStatsFromJSON,
    ProjectDomainWithStatsToJSON,
    ProjectInputFromJSON,
    ProjectInputToJSON,
    ProjectInvitationFromJSON,
    ProjectInvitationToJSON,
    ProjectOrderStatusSettingsFromJSON,
    ProjectOrderStatusSettingsToJSON,
    ProjectRoleFromJSON,
    ProjectRoleToJSON,
    ProjectRoleOutputFromJSON,
    ProjectRoleOutputToJSON,
    ProjectRuntimeOverviewFromJSON,
    ProjectRuntimeOverviewToJSON,
    ProjectStatusUpdateFromJSON,
    ProjectStatusUpdateToJSON,
    ProjectUsers200ResponseFromJSON,
    ProjectUsers200ResponseToJSON,
    RemoveUserInputFromJSON,
    RemoveUserInputToJSON,
    SetOwnerInputFromJSON,
    SetOwnerInputToJSON,
    SetRoleInputFromJSON,
    SetRoleInputToJSON,
    SingleCampaignOverviewFromJSON,
    SingleCampaignOverviewToJSON,
    UpdateSubscriptionInputFromJSON,
    UpdateSubscriptionInputToJSON,
} from '../models/index';

export interface ChangeBillingAccountRequest {
    projectId: string;
    billingAccountInput?: BillingAccountInput;
}

export interface CreateOrUpdateProjectDomainRequest {
    projectId: string;
    createOrUpdateProjectDomainInput?: CreateOrUpdateProjectDomainInput;
}

export interface CreateOtherSystemSourceRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    createOtherSystemSourceInput?: CreateOtherSystemSourceInput;
}

export interface CreateOtherSystemSourceInsightsRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
    createOtherSystemSourceInsightInput?: CreateOtherSystemSourceInsightInput;
}

export interface CreateProjectRequest {
    projectInput?: ProjectInput;
}

export interface CreateProjectRoleRequest {
    projectId: string;
    createRoleInput?: CreateRoleInput;
}

export interface DeleteOtherSystemSourceRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
}

export interface DeleteOtherSystemSourceInsightRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
    deleteOtherSystemSourceInsightInput?: DeleteOtherSystemSourceInsightInput;
}

export interface DeleteProjectRequest {
    projectId: string;
}

export interface DeleteProjectDomainRequest {
    projectId: string;
    deleteProjectDomainInput?: DeleteProjectDomainInput;
}

export interface DeleteProjectInviteRequest {
    projectId: string;
    inviteId: string;
}

export interface DeleteProjectRoleRequest {
    projectId: string;
    roleId: string;
}

export interface GetDomainsStatusChangePriceRequest {
    projectId: string;
    createOrUpdateProjectDomainInput?: Array<CreateOrUpdateProjectDomainInput>;
}

export interface GetPaymentMethodRequest {
    projectId: string;
    updateSubscriptionInput?: UpdateSubscriptionInput;
}

export interface GetProjectRoleRequest {
    projectId: string;
    roleId: string;
}

export interface HostNameAndCSVLinkRequest {
    integrationId: string;
}

export interface HostNameAndTLDAndApiKeyRequest {
    integrationId: string;
}

export interface HostNameAndXMLLinkRequest {
    integrationId: string;
}

export interface HostNameApiIdApiKeyRequest {
    integrationId: string;
}

export interface IntegrationWorkerURLRequest {
    integrationId: string;
}

export interface InviteUserRequest {
    projectId: string;
    inviteUserInput?: InviteUserInput;
}

export interface ListProjectCentresRequest {
    projectId: string;
}

export interface ListProjectDomainsRequest {
    projectId: string;
}

export interface MarketingChannelCampaignDataRequest {
    projectId: string;
    channelId: string;
    campaignRemoteId: string;
    dateRangeInput?: DateRangeInput;
}

export interface MarketingChannelDataRequest {
    projectId: string;
    channelId: string;
    erpFilter?: ErpFilter;
}

export interface MarketingChannelsRequest {
    projectId: string;
}

export interface ModifyOrderStatusListRequest {
    projectId: string;
    projectStatusUpdate?: ProjectStatusUpdate;
}

export interface ModifyOtherSystemSourceRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
    modifyOtherSystemSourceInput?: ModifyOtherSystemSourceInput;
}

export interface ModifyOtherSystemSourceInsightsRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
    modifyOtherSystemSourceInsightInput?: ModifyOtherSystemSourceInsightInput;
}

export interface NewPaymentSetupRequest {
    projectId: string;
}

export interface OrderStatusListRequest {
    projectId: string;
}

export interface OtherSystemSourceInsightsRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
    otherSystemSourceId: string;
}

export interface OtherSystemSourcesRequest {
    projectId: string;
    otherSystemType: OtherSystemType;
}

export interface PatchProjectRoleRequest {
    projectId: string;
    roleId: string;
    patchRoleInput?: PatchRoleInput;
}

export interface ProjectInvitesRequest {
    projectId: string;
}

export interface ProjectRolesRequest {
    projectId: string;
}

export interface ProjectStatusRequest {
    projectId: string;
}

export interface ProjectUsersRequest {
    projectId: string;
    page?: number;
    searchTerm?: string;
}

export interface RemoveProjectUserRequest {
    projectId: string;
    removeUserInput?: RemoveUserInput;
}

export interface SetProjectBillingAccountRequest {
    projectId: string;
    projectBillingAccountInput?: ProjectBillingAccountInput;
}

export interface TouchProjectRequest {
    projectId: string;
}

export interface UpdateProjectRequest {
    projectId: string;
    projectInput?: ProjectInput;
}

export interface UpdateProjectDomainsStatusRequest {
    projectId: string;
    createOrUpdateProjectDomainInput?: Array<CreateOrUpdateProjectDomainInput>;
}

export interface UpdateProjectOwnerRequest {
    projectId: string;
    userId: string;
    setOwnerInput?: SetOwnerInput;
}

export interface UpdateProjectRoleRequest {
    projectId: string;
    userId: string;
    setRoleInput?: SetRoleInput;
}

export interface UploadLogoRequest {
    projectId: string;
    logo?: Blob;
}

/**
 * 
 */
export class ProjectApi extends runtime.BaseAPI {

    /**
     * Creates request options for changeBillingAccount without sending the request
     */
    async changeBillingAccountRequestOpts(requestParameters: ChangeBillingAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling changeBillingAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/billing-account`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BillingAccountInputToJSON(requestParameters['billingAccountInput']),
        };
    }

    /**
     * Change project\'s billing account.
     */
    async changeBillingAccountRaw(requestParameters: ChangeBillingAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BillingAccountData>> {
        const requestOptions = await this.changeBillingAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingAccountDataFromJSON(jsonValue));
    }

    /**
     * Change project\'s billing account.
     */
    async changeBillingAccount(requestParameters: ChangeBillingAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BillingAccountData> {
        const response = await this.changeBillingAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOrUpdateProjectDomain without sending the request
     */
    async createOrUpdateProjectDomainRequestOpts(requestParameters: CreateOrUpdateProjectDomainRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createOrUpdateProjectDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/domains`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateProjectDomainInputToJSON(requestParameters['createOrUpdateProjectDomainInput']),
        };
    }

    /**
     * Creates or updates projects by host name.
     */
    async createOrUpdateProjectDomainRaw(requestParameters: CreateOrUpdateProjectDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.createOrUpdateProjectDomainRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Creates or updates projects by host name.
     */
    async createOrUpdateProjectDomain(requestParameters: CreateOrUpdateProjectDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.createOrUpdateProjectDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOtherSystemSource without sending the request
     */
    async createOtherSystemSourceRequestOpts(requestParameters: CreateOtherSystemSourceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createOtherSystemSource().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling createOtherSystemSource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"otherSystemType"}}`, encodeURIComponent(String(requestParameters['otherSystemType'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOtherSystemSourceInputToJSON(requestParameters['createOtherSystemSourceInput']),
        };
    }

    /**
     * Creates new source.
     */
    async createOtherSystemSourceRaw(requestParameters: CreateOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.createOtherSystemSourceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Creates new source.
     */
    async createOtherSystemSource(requestParameters: CreateOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.createOtherSystemSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOtherSystemSourceInsights without sending the request
     */
    async createOtherSystemSourceInsightsRequestOpts(requestParameters: CreateOtherSystemSourceInsightsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createOtherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling createOtherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling createOtherSystemSourceInsights().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/{otherSystemSourceId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"otherSystemType"}}`, encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace(`{${"otherSystemSourceId"}}`, encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOtherSystemSourceInsightInputToJSON(requestParameters['createOtherSystemSourceInsightInput']),
        };
    }

    /**
     * Creates new insight.
     */
    async createOtherSystemSourceInsightsRaw(requestParameters: CreateOtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.createOtherSystemSourceInsightsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Creates new insight.
     */
    async createOtherSystemSourceInsights(requestParameters: CreateOtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.createOtherSystemSourceInsightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createProject without sending the request
     */
    async createProjectRequestOpts(requestParameters: CreateProjectRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/create`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectInputToJSON(requestParameters['projectInput']),
        };
    }

    /**
     * Creates a project owned by the currently authenticated user.
     */
    async createProjectRaw(requestParameters: CreateProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectData>> {
        const requestOptions = await this.createProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDataFromJSON(jsonValue));
    }

    /**
     * Creates a project owned by the currently authenticated user.
     */
    async createProject(requestParameters: CreateProjectRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectData> {
        const response = await this.createProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createProjectRole without sending the request
     */
    async createProjectRoleRequestOpts(requestParameters: CreateProjectRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createProjectRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/role`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRoleInputToJSON(requestParameters['createRoleInput']),
        };
    }

    /**
     * Creates a role.
     */
    async createProjectRoleRaw(requestParameters: CreateProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.createProjectRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Creates a role.
     */
    async createProjectRole(requestParameters: CreateProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.createProjectRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteOtherSystemSource without sending the request
     */
    async deleteOtherSystemSourceRequestOpts(requestParameters: DeleteOtherSystemSourceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteOtherSystemSource().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling deleteOtherSystemSource().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling deleteOtherSystemSource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/source/{otherSystemSourceId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"otherSystemType"}}`, encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace(`{${"otherSystemSourceId"}}`, encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes existing source.
     */
    async deleteOtherSystemSourceRaw(requestParameters: DeleteOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteOtherSystemSourceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Deletes existing source.
     */
    async deleteOtherSystemSource(requestParameters: DeleteOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteOtherSystemSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteOtherSystemSourceInsight without sending the request
     */
    async deleteOtherSystemSourceInsightRequestOpts(requestParameters: DeleteOtherSystemSourceInsightRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteOtherSystemSourceInsight().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling deleteOtherSystemSourceInsight().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling deleteOtherSystemSourceInsight().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/{otherSystemSourceId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"otherSystemType"}}`, encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace(`{${"otherSystemSourceId"}}`, encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteOtherSystemSourceInsightInputToJSON(requestParameters['deleteOtherSystemSourceInsightInput']),
        };
    }

    /**
     * Deletes existing insight.
     */
    async deleteOtherSystemSourceInsightRaw(requestParameters: DeleteOtherSystemSourceInsightRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteOtherSystemSourceInsightRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Deletes existing insight.
     */
    async deleteOtherSystemSourceInsight(requestParameters: DeleteOtherSystemSourceInsightRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteOtherSystemSourceInsightRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteProject without sending the request
     */
    async deleteProjectRequestOpts(requestParameters: DeleteProjectRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes the project.
     */
    async deleteProjectRaw(requestParameters: DeleteProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Deletes the project.
     */
    async deleteProject(requestParameters: DeleteProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteProjectDomain without sending the request
     */
    async deleteProjectDomainRequestOpts(requestParameters: DeleteProjectDomainRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteProjectDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/domains`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteProjectDomainInputToJSON(requestParameters['deleteProjectDomainInput']),
        };
    }

    /**
     * Returns list of project domains.
     */
    async deleteProjectDomainRaw(requestParameters: DeleteProjectDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteProjectDomainRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns list of project domains.
     */
    async deleteProjectDomain(requestParameters: DeleteProjectDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteProjectDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteProjectInvite without sending the request
     */
    async deleteProjectInviteRequestOpts(requestParameters: DeleteProjectInviteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteProjectInvite().'
            );
        }

        if (requestParameters['inviteId'] == null) {
            throw new runtime.RequiredError(
                'inviteId',
                'Required parameter "inviteId" was null or undefined when calling deleteProjectInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/invite/{inviteId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"inviteId"}}`, encodeURIComponent(String(requestParameters['inviteId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all the invites available on this project.
     */
    async deleteProjectInviteRaw(requestParameters: DeleteProjectInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteProjectInviteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns all the invites available on this project.
     */
    async deleteProjectInvite(requestParameters: DeleteProjectInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteProjectInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteProjectRole without sending the request
     */
    async deleteProjectRoleRequestOpts(requestParameters: DeleteProjectRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteProjectRole().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling deleteProjectRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/role/{roleId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes a role.
     */
    async deleteProjectRoleRaw(requestParameters: DeleteProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.deleteProjectRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Deletes a role.
     */
    async deleteProjectRole(requestParameters: DeleteProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.deleteProjectRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDomainsStatusChangePrice without sending the request
     */
    async getDomainsStatusChangePriceRequestOpts(requestParameters: GetDomainsStatusChangePriceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getDomainsStatusChangePrice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/domains/status/price`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createOrUpdateProjectDomainInput']!.map(CreateOrUpdateProjectDomainInputToJSON),
        };
    }

    /**
     * Find out if an additional payment is needed to change domain statuses
     */
    async getDomainsStatusChangePriceRaw(requestParameters: GetDomainsStatusChangePriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectDomainAdditionalPaymentData>> {
        const requestOptions = await this.getDomainsStatusChangePriceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDomainAdditionalPaymentDataFromJSON(jsonValue));
    }

    /**
     * Find out if an additional payment is needed to change domain statuses
     */
    async getDomainsStatusChangePrice(requestParameters: GetDomainsStatusChangePriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectDomainAdditionalPaymentData> {
        const response = await this.getDomainsStatusChangePriceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentMethod without sending the request
     */
    async getPaymentMethodRequestOpts(requestParameters: GetPaymentMethodRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getPaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/payment-method`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubscriptionInputToJSON(requestParameters['updateSubscriptionInput']),
        };
    }

    /**
     * Get payment method from Stripe Customer by customer ID.
     */
    async getPaymentMethodRaw(requestParameters: GetPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CardData>> {
        const requestOptions = await this.getPaymentMethodRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CardDataFromJSON(jsonValue));
    }

    /**
     * Get payment method from Stripe Customer by customer ID.
     */
    async getPaymentMethod(requestParameters: GetPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CardData> {
        const response = await this.getPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProjectRole without sending the request
     */
    async getProjectRoleRequestOpts(requestParameters: GetProjectRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectRole().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling getProjectRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/role/{roleId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns single role.
     */
    async getProjectRoleRaw(requestParameters: GetProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectRoleOutput>> {
        const requestOptions = await this.getProjectRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectRoleOutputFromJSON(jsonValue));
    }

    /**
     * Returns single role.
     */
    async getProjectRole(requestParameters: GetProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectRoleOutput> {
        const response = await this.getProjectRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for hostNameAndCSVLink without sending the request
     */
    async hostNameAndCSVLinkRequestOpts(requestParameters: HostNameAndCSVLinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling hostNameAndCSVLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/{integrationId}/host-name-and-csv-link`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get integration hostname and CSV link list.
     */
    async hostNameAndCSVLinkRaw(requestParameters: HostNameAndCSVLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HostNameAndCsvLinkData>>> {
        const requestOptions = await this.hostNameAndCSVLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HostNameAndCsvLinkDataFromJSON));
    }

    /**
     * Get integration hostname and CSV link list.
     */
    async hostNameAndCSVLink(requestParameters: HostNameAndCSVLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HostNameAndCsvLinkData>> {
        const response = await this.hostNameAndCSVLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for hostNameAndTLDAndApiKey without sending the request
     */
    async hostNameAndTLDAndApiKeyRequestOpts(requestParameters: HostNameAndTLDAndApiKeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling hostNameAndTLDAndApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/{integrationId}/host-name-and-tld-and-api-key`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get integration hostname, tld and api key list.
     */
    async hostNameAndTLDAndApiKeyRaw(requestParameters: HostNameAndTLDAndApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HostNameAndTldAndApiCurrencyCodeApiKeyData>>> {
        const requestOptions = await this.hostNameAndTLDAndApiKeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HostNameAndTldAndApiCurrencyCodeApiKeyDataFromJSON));
    }

    /**
     * Get integration hostname, tld and api key list.
     */
    async hostNameAndTLDAndApiKey(requestParameters: HostNameAndTLDAndApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HostNameAndTldAndApiCurrencyCodeApiKeyData>> {
        const response = await this.hostNameAndTLDAndApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for hostNameAndXMLLink without sending the request
     */
    async hostNameAndXMLLinkRequestOpts(requestParameters: HostNameAndXMLLinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling hostNameAndXMLLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/{integrationId}/host-name-and-xml-link`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get integration hostname and XML link list.
     */
    async hostNameAndXMLLinkRaw(requestParameters: HostNameAndXMLLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HostNameAndXmlLinkData>>> {
        const requestOptions = await this.hostNameAndXMLLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HostNameAndXmlLinkDataFromJSON));
    }

    /**
     * Get integration hostname and XML link list.
     */
    async hostNameAndXMLLink(requestParameters: HostNameAndXMLLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HostNameAndXmlLinkData>> {
        const response = await this.hostNameAndXMLLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for hostNameApiIdApiKey without sending the request
     */
    async hostNameApiIdApiKeyRequestOpts(requestParameters: HostNameApiIdApiKeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling hostNameApiIdApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/{integrationId}/host-name-api-id-api-key`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get integration hostname, apiId and apiKey list.
     */
    async hostNameApiIdApiKeyRaw(requestParameters: HostNameApiIdApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HostNameApiIdApiKeyData>>> {
        const requestOptions = await this.hostNameApiIdApiKeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HostNameApiIdApiKeyDataFromJSON));
    }

    /**
     * Get integration hostname, apiId and apiKey list.
     */
    async hostNameApiIdApiKey(requestParameters: HostNameApiIdApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HostNameApiIdApiKeyData>> {
        const response = await this.hostNameApiIdApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for integrationWorkerURL without sending the request
     */
    async integrationWorkerURLRequestOpts(requestParameters: IntegrationWorkerURLRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling integrationWorkerURL().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/integration/{integrationId}/worker-url`;
        urlPath = urlPath.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get URL of integration worker.
     */
    async integrationWorkerURLRaw(requestParameters: IntegrationWorkerURLRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectUsers200Response>> {
        const requestOptions = await this.integrationWorkerURLRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectUsers200ResponseFromJSON(jsonValue));
    }

    /**
     * Get URL of integration worker.
     */
    async integrationWorkerURL(requestParameters: IntegrationWorkerURLRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectUsers200Response> {
        const response = await this.integrationWorkerURLRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for inviteUser without sending the request
     */
    async inviteUserRequestOpts(requestParameters: InviteUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling inviteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/invite`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteUserInputToJSON(requestParameters['inviteUserInput']),
        };
    }

    /**
     * Sends an invite link to an e-mail address.
     */
    async inviteUserRaw(requestParameters: InviteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.inviteUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Sends an invite link to an e-mail address.
     */
    async inviteUser(requestParameters: InviteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.inviteUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listProjectCentres without sending the request
     */
    async listProjectCentresRequestOpts(requestParameters: ListProjectCentresRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectCentres().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/centres`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns list of project centres.
     */
    async listProjectCentresRaw(requestParameters: ListProjectCentresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProjectCentreWithDomains>>> {
        const requestOptions = await this.listProjectCentresRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectCentreWithDomainsFromJSON));
    }

    /**
     * Returns list of project centres.
     */
    async listProjectCentres(requestParameters: ListProjectCentresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProjectCentreWithDomains>> {
        const response = await this.listProjectCentresRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listProjectDomains without sending the request
     */
    async listProjectDomainsRequestOpts(requestParameters: ListProjectDomainsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectDomains().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/domains`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns list of project domains.
     */
    async listProjectDomainsRaw(requestParameters: ListProjectDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProjectDomainWithStats>>> {
        const requestOptions = await this.listProjectDomainsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectDomainWithStatsFromJSON));
    }

    /**
     * Returns list of project domains.
     */
    async listProjectDomains(requestParameters: ListProjectDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProjectDomainWithStats>> {
        const response = await this.listProjectDomainsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for marketingChannelCampaignData without sending the request
     */
    async marketingChannelCampaignDataRequestOpts(requestParameters: MarketingChannelCampaignDataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling marketingChannelCampaignData().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling marketingChannelCampaignData().'
            );
        }

        if (requestParameters['campaignRemoteId'] == null) {
            throw new runtime.RequiredError(
                'campaignRemoteId',
                'Required parameter "campaignRemoteId" was null or undefined when calling marketingChannelCampaignData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/marketing-channel/{channelId}/campaign-detail/{campaignRemoteId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"campaignRemoteId"}}`, encodeURIComponent(String(requestParameters['campaignRemoteId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        };
    }

    /**
     * Returns marketing channel campaign data.
     */
    async marketingChannelCampaignDataRaw(requestParameters: MarketingChannelCampaignDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleCampaignOverview>> {
        const requestOptions = await this.marketingChannelCampaignDataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleCampaignOverviewFromJSON(jsonValue));
    }

    /**
     * Returns marketing channel campaign data.
     */
    async marketingChannelCampaignData(requestParameters: MarketingChannelCampaignDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleCampaignOverview> {
        const response = await this.marketingChannelCampaignDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for marketingChannelData without sending the request
     */
    async marketingChannelDataRequestOpts(requestParameters: MarketingChannelDataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling marketingChannelData().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling marketingChannelData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/marketing-channel/{channelId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns marketing channel data.
     */
    async marketingChannelDataRaw(requestParameters: MarketingChannelDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChannelOverview>> {
        const requestOptions = await this.marketingChannelDataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChannelOverviewFromJSON(jsonValue));
    }

    /**
     * Returns marketing channel data.
     */
    async marketingChannelData(requestParameters: MarketingChannelDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChannelOverview> {
        const response = await this.marketingChannelDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for marketingChannels without sending the request
     */
    async marketingChannelsRequestOpts(requestParameters: MarketingChannelsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling marketingChannels().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/marketing-channels`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns marketing channel list.
     */
    async marketingChannelsRaw(requestParameters: MarketingChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarketingChannelList>> {
        const requestOptions = await this.marketingChannelsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarketingChannelListFromJSON(jsonValue));
    }

    /**
     * Returns marketing channel list.
     */
    async marketingChannels(requestParameters: MarketingChannelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarketingChannelList> {
        const response = await this.marketingChannelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for modifyOrderStatusList without sending the request
     */
    async modifyOrderStatusListRequestOpts(requestParameters: ModifyOrderStatusListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling modifyOrderStatusList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/order-status-list`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectStatusUpdateToJSON(requestParameters['projectStatusUpdate']),
        };
    }

    /**
     * Returns status list.
     */
    async modifyOrderStatusListRaw(requestParameters: ModifyOrderStatusListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.modifyOrderStatusListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns status list.
     */
    async modifyOrderStatusList(requestParameters: ModifyOrderStatusListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.modifyOrderStatusListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for modifyOtherSystemSource without sending the request
     */
    async modifyOtherSystemSourceRequestOpts(requestParameters: ModifyOtherSystemSourceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling modifyOtherSystemSource().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling modifyOtherSystemSource().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling modifyOtherSystemSource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/source/{otherSystemSourceId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"otherSystemType"}}`, encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace(`{${"otherSystemSourceId"}}`, encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ModifyOtherSystemSourceInputToJSON(requestParameters['modifyOtherSystemSourceInput']),
        };
    }

    /**
     * Modifies existing source.
     */
    async modifyOtherSystemSourceRaw(requestParameters: ModifyOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.modifyOtherSystemSourceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Modifies existing source.
     */
    async modifyOtherSystemSource(requestParameters: ModifyOtherSystemSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.modifyOtherSystemSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for modifyOtherSystemSourceInsights without sending the request
     */
    async modifyOtherSystemSourceInsightsRequestOpts(requestParameters: ModifyOtherSystemSourceInsightsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling modifyOtherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling modifyOtherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling modifyOtherSystemSourceInsights().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/{otherSystemSourceId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"otherSystemType"}}`, encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace(`{${"otherSystemSourceId"}}`, encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ModifyOtherSystemSourceInsightInputToJSON(requestParameters['modifyOtherSystemSourceInsightInput']),
        };
    }

    /**
     * Modifies existing insight.
     */
    async modifyOtherSystemSourceInsightsRaw(requestParameters: ModifyOtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.modifyOtherSystemSourceInsightsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Modifies existing insight.
     */
    async modifyOtherSystemSourceInsights(requestParameters: ModifyOtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.modifyOtherSystemSourceInsightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for newPaymentSetup without sending the request
     */
    async newPaymentSetupRequestOpts(requestParameters: NewPaymentSetupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling newPaymentSetup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/new-payment-setup`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * New payment setup.
     */
    async newPaymentSetupRaw(requestParameters: NewPaymentSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentSetupData>> {
        const requestOptions = await this.newPaymentSetupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentSetupDataFromJSON(jsonValue));
    }

    /**
     * New payment setup.
     */
    async newPaymentSetup(requestParameters: NewPaymentSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentSetupData> {
        const response = await this.newPaymentSetupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for orderStatusList without sending the request
     */
    async orderStatusListRequestOpts(requestParameters: OrderStatusListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling orderStatusList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/order-status-list`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns status list.
     */
    async orderStatusListRaw(requestParameters: OrderStatusListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectOrderStatusSettings>> {
        const requestOptions = await this.orderStatusListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectOrderStatusSettingsFromJSON(jsonValue));
    }

    /**
     * Returns status list.
     */
    async orderStatusList(requestParameters: OrderStatusListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectOrderStatusSettings> {
        const response = await this.orderStatusListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for otherSystemSourceInsights without sending the request
     */
    async otherSystemSourceInsightsRequestOpts(requestParameters: OtherSystemSourceInsightsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling otherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling otherSystemSourceInsights().'
            );
        }

        if (requestParameters['otherSystemSourceId'] == null) {
            throw new runtime.RequiredError(
                'otherSystemSourceId',
                'Required parameter "otherSystemSourceId" was null or undefined when calling otherSystemSourceInsights().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}/{otherSystemSourceId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"otherSystemType"}}`, encodeURIComponent(String(requestParameters['otherSystemType'])));
        urlPath = urlPath.replace(`{${"otherSystemSourceId"}}`, encodeURIComponent(String(requestParameters['otherSystemSourceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns other system source insights.
     */
    async otherSystemSourceInsightsRaw(requestParameters: OtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OtherSystemSourceInsight>>> {
        const requestOptions = await this.otherSystemSourceInsightsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OtherSystemSourceInsightFromJSON));
    }

    /**
     * Returns other system source insights.
     */
    async otherSystemSourceInsights(requestParameters: OtherSystemSourceInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OtherSystemSourceInsight>> {
        const response = await this.otherSystemSourceInsightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for otherSystemSources without sending the request
     */
    async otherSystemSourcesRequestOpts(requestParameters: OtherSystemSourcesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling otherSystemSources().'
            );
        }

        if (requestParameters['otherSystemType'] == null) {
            throw new runtime.RequiredError(
                'otherSystemType',
                'Required parameter "otherSystemType" was null or undefined when calling otherSystemSources().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/other-systems/{otherSystemType}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"otherSystemType"}}`, encodeURIComponent(String(requestParameters['otherSystemType'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns other system sources by type.
     */
    async otherSystemSourcesRaw(requestParameters: OtherSystemSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OtherSystemSourceWithCentreAndDomain>>> {
        const requestOptions = await this.otherSystemSourcesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OtherSystemSourceWithCentreAndDomainFromJSON));
    }

    /**
     * Returns other system sources by type.
     */
    async otherSystemSources(requestParameters: OtherSystemSourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OtherSystemSourceWithCentreAndDomain>> {
        const response = await this.otherSystemSourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for patchProjectRole without sending the request
     */
    async patchProjectRoleRequestOpts(requestParameters: PatchProjectRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling patchProjectRole().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling patchProjectRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/role/{roleId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchRoleInputToJSON(requestParameters['patchRoleInput']),
        };
    }

    /**
     * Patches a role.
     */
    async patchProjectRoleRaw(requestParameters: PatchProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.patchProjectRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Patches a role.
     */
    async patchProjectRole(requestParameters: PatchProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.patchProjectRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectInvites without sending the request
     */
    async projectInvitesRequestOpts(requestParameters: ProjectInvitesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling projectInvites().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/invites`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all the invites available on this project.
     */
    async projectInvitesRaw(requestParameters: ProjectInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProjectInvitation>>> {
        const requestOptions = await this.projectInvitesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectInvitationFromJSON));
    }

    /**
     * Returns all the invites available on this project.
     */
    async projectInvites(requestParameters: ProjectInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProjectInvitation>> {
        const response = await this.projectInvitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectRoles without sending the request
     */
    async projectRolesRequestOpts(requestParameters: ProjectRolesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling projectRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/roles`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns project roles.
     */
    async projectRolesRaw(requestParameters: ProjectRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProjectRole>>> {
        const requestOptions = await this.projectRolesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectRoleFromJSON));
    }

    /**
     * Returns project roles.
     */
    async projectRoles(requestParameters: ProjectRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProjectRole>> {
        const response = await this.projectRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectStatus without sending the request
     */
    async projectStatusRequestOpts(requestParameters: ProjectStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling projectStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/{projectId}/status`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns quick info about the state of project update.
     */
    async projectStatusRaw(requestParameters: ProjectStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectRuntimeOverview>> {
        const requestOptions = await this.projectStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectRuntimeOverviewFromJSON(jsonValue));
    }

    /**
     * Returns quick info about the state of project update.
     */
    async projectStatus(requestParameters: ProjectStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectRuntimeOverview> {
        const response = await this.projectStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectUsers without sending the request
     */
    async projectUsersRequestOpts(requestParameters: ProjectUsersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling projectUsers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['searchTerm'] != null) {
            queryParameters['searchTerm'] = requestParameters['searchTerm'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/users`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists users by project.
     */
    async projectUsersRaw(requestParameters: ProjectUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectUsers200Response>> {
        const requestOptions = await this.projectUsersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectUsers200ResponseFromJSON(jsonValue));
    }

    /**
     * Lists users by project.
     */
    async projectUsers(requestParameters: ProjectUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectUsers200Response> {
        const response = await this.projectUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeProjectUser without sending the request
     */
    async removeProjectUserRequestOpts(requestParameters: RemoveProjectUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling removeProjectUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/users`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveUserInputToJSON(requestParameters['removeUserInput']),
        };
    }

    /**
     * Revokes access to the user.  Only owner can remove users.
     */
    async removeProjectUserRaw(requestParameters: RemoveProjectUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.removeProjectUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Revokes access to the user.  Only owner can remove users.
     */
    async removeProjectUser(requestParameters: RemoveProjectUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.removeProjectUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setProjectBillingAccount without sending the request
     */
    async setProjectBillingAccountRequestOpts(requestParameters: SetProjectBillingAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling setProjectBillingAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/set-billing-account`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectBillingAccountInputToJSON(requestParameters['projectBillingAccountInput']),
        };
    }

    /**
     * Updates the project billing account.
     */
    async setProjectBillingAccountRaw(requestParameters: SetProjectBillingAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectData>> {
        const requestOptions = await this.setProjectBillingAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDataFromJSON(jsonValue));
    }

    /**
     * Updates the project billing account.
     */
    async setProjectBillingAccount(requestParameters: SetProjectBillingAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectData> {
        const response = await this.setProjectBillingAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for touchProject without sending the request
     */
    async touchProjectRequestOpts(requestParameters: TouchProjectRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling touchProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/touch`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Updates the project last interaction to move it higher in the list.
     */
    async touchProjectRaw(requestParameters: TouchProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.touchProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Updates the project last interaction to move it higher in the list.
     */
    async touchProject(requestParameters: TouchProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.touchProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateProject without sending the request
     */
    async updateProjectRequestOpts(requestParameters: UpdateProjectRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectInputToJSON(requestParameters['projectInput']),
        };
    }

    /**
     * Defined values will be changed for the project, other undefined  will stay the same.
     */
    async updateProjectRaw(requestParameters: UpdateProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectData>> {
        const requestOptions = await this.updateProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDataFromJSON(jsonValue));
    }

    /**
     * Defined values will be changed for the project, other undefined  will stay the same.
     */
    async updateProject(requestParameters: UpdateProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectData> {
        const response = await this.updateProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateProjectDomainsStatus without sending the request
     */
    async updateProjectDomainsStatusRequestOpts(requestParameters: UpdateProjectDomainsStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProjectDomainsStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/domains/status`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createOrUpdateProjectDomainInput']!.map(CreateOrUpdateProjectDomainInputToJSON),
        };
    }

    /**
     * Updates multiple project domains status at once.
     */
    async updateProjectDomainsStatusRaw(requestParameters: UpdateProjectDomainsStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateProjectDomainsStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Updates multiple project domains status at once.
     */
    async updateProjectDomainsStatus(requestParameters: UpdateProjectDomainsStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateProjectDomainsStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateProjectOwner without sending the request
     */
    async updateProjectOwnerRequestOpts(requestParameters: UpdateProjectOwnerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProjectOwner().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateProjectOwner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/{userId}/set-owner`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetOwnerInputToJSON(requestParameters['setOwnerInput']),
        };
    }

    /**
     * Updates project owner.
     */
    async updateProjectOwnerRaw(requestParameters: UpdateProjectOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.updateProjectOwnerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates project owner.
     */
    async updateProjectOwner(requestParameters: UpdateProjectOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.updateProjectOwnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateProjectRole without sending the request
     */
    async updateProjectRoleRequestOpts(requestParameters: UpdateProjectRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProjectRole().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateProjectRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/{projectId}/{userId}/set-role`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetRoleInputToJSON(requestParameters['setRoleInput']),
        };
    }

    /**
     * Updates project role.
     */
    async updateProjectRoleRaw(requestParameters: UpdateProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.updateProjectRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates project role.
     */
    async updateProjectRole(requestParameters: UpdateProjectRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.updateProjectRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadLogo without sending the request
     */
    async uploadLogoRequestOpts(requestParameters: UploadLogoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling uploadLogo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['logo'] != null) {
            formParams.append('logo', requestParameters['logo'] as any);
        }


        let urlPath = `/api/v1/project/{projectId}/logo`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     * Users with `ProjectProfile` permission can do this action.
     */
    async uploadLogoRaw(requestParameters: UploadLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectData>> {
        const requestOptions = await this.uploadLogoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDataFromJSON(jsonValue));
    }

    /**
     * Users with `ProjectProfile` permission can do this action.
     */
    async uploadLogo(requestParameters: UploadLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectData> {
        const response = await this.uploadLogoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
